<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-start`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_3b38a6300c__clip0_4044_285953)"><path d="M8.00024 0.800781C11.9766 0.800887 15.2004 4.02459 15.2004 8.00098C15.2003 11.9773 11.9765 15.2011 8.00024 15.2012C4.02386 15.2012 0.800154 11.9773 0.800049 8.00098C0.800049 4.02453 4.02379 0.800781 8.00024 0.800781ZM6.65649 5.45996C6.51347 5.47862 6.36375 5.56084 6.27173 5.67188C6.1613 5.80529 6.13652 5.99878 6.08618 6.38477C5.92906 7.58963 5.93612 8.5386 6.09595 9.70605C6.14522 10.0659 6.16914 10.2467 6.27466 10.377C6.36147 10.484 6.50776 10.5684 6.6438 10.5908C6.80935 10.6179 6.97608 10.551 7.30884 10.417C8.34333 10.0004 9.16188 9.52255 10.1672 8.75586C10.4836 8.51458 10.6419 8.39396 10.7024 8.23145C10.7531 8.09507 10.7506 7.92533 10.6946 7.79102C10.6278 7.63087 10.4635 7.51543 10.136 7.28516C9.19642 6.62461 8.39939 6.16395 7.36548 5.68555C7.00766 5.51998 6.82835 5.43767 6.65649 5.45996Z"/></g><defs><clipPath id="svg_3b38a6300c__clip0_4044_285953"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconFillStart',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
